/**
 * 3.1.3.2 외부 연동 좀비 PC 탐지 솔루션 Tab Store
 *
 * @since 2018-08-02
 * @author devp020
 */

import {i18n} from '~/plugins/i18n'

const initZombieData = () => {
  return {
    device_id_list: [],
    device_list_name: '',
    zombie_cm_device: [],
    zombie_cm_desc: '',
    zombie_cm_id: 1,
    zombie_cm_sync_yn: 1,
    zombie_cm_uname: ''
  }
}

const initZombieLinkageData = () => {
  return {
    zombie_block_num: 100,
    zombie_cm_id: 0,
    zombie_id: 0,
    zombie_desc: '',
    zombie_ip: '',
    zombie_type: 1,
    zombie_use_yn: 0
  }
}
export const state = () => ({
  selectOptions: [
    {label: 'FireEye', value: 0}, {label: 'Symantec', value: 1}, {label: 'SECUI', value: 2}
  ],
  // api url 목록
  apiUrl: {
    zombiePcBlockUrl: '/api/cm/zombie-cm',
    zombiePcBlockLinkageUrl: '/api/cm/zombie'
  },

  zombiePcBlockList: [],
  selectedData: initZombieData(),
  selectedLinkageData: initZombieLinkageData(),
  zombiePcBlockResult: null,
  zombiePcBlockSyncResult: null,
  zombiePcBlockLinkageList: [],
  zombiePcBlockLinkageResult: null,
  selectRowItem: {},
  selectLinkageRowItem: {}
})

export const mutations = {
  // Row DoubleClick
  setSelectRowItem (state, data) {
    state.selectRowItem = data
  },
  // Row Linkage DoubleClick
  setSelectLinkageRowItem (state, data) {
    state.selectLinkageRowItem = data
  },
  // 좀비 PC 탐지 솔루션 연동 조회
  mutZombiePcBlock (state, payload) {
    state.zombiePcBlockList = payload.filter(item => {
      // item.device_id_list = '<div>' + item.zombie_cm_device.map(item => {
      //   return item.device_uname
      // }).join('</div><div>') + '</div>'
      item.device_id_list = item.zombie_cm_device.map(itm => itm.device_id)
      return item
    })
  },
  // 좀비 PC 탐지 솔루션 편집 데이터 조회
  mutZombiePcBlockGetData (state, data) {
    const selectedRowData = data[0]
    selectedRowData.device_list_name = ''
    selectedRowData.device_id_list = []
    const deviceInfo = selectedRowData.zombie_cm_device
    if (deviceInfo.length > 0) {
      const deviceName = deviceInfo[0].device_uname
      const deviceLen = deviceInfo.length
      let result = void 0
      if (deviceLen > 1) {
        result = i18n.t('cmn.deviceTypeText', {name: deviceName, cnt: deviceLen - 1})
        // result = `${deviceName} 외 ${deviceLen - 1} 대`
      } else if (deviceLen === 1) {
        result = `${deviceName}`
      } else {
        result = ''
      }
      selectedRowData.device_list_name = result
      selectedRowData.device_id_list = deviceInfo.map(item => item.device_id)
    }
    state.selectedData = selectedRowData
  },
  mutZombieSettingsLinkageSetData (state, data) {
    state.selectedLinkageData = _.cloneDeep(data)
  },
  // 좀비 PC 탐지 솔루션 편집 데이터 초기화
  mutZombieSettingsResetData (state) {
    state.selectedData = initZombieData()
  },
  // 좀비 PC 탐지 솔루션 연동 편집 데이터 초기화
  mutZombieSettingsLinkageResetData (state) {
    state.selectedLinkageData = initZombieLinkageData()
  },
  // 좀비 PC 탐지 솔루션 (빈설정)
  mutAddEmptySettings: (state, item) => {
    state.zombiePcBlockList.push(item)
  },
  // 좀비 PC 탐지 솔루션 완료 처리 / 수정
  mutPutZombiePcBlock (state, payload) {
    state.zombiePcBlockResult = payload
  },
  // 좀비 PC 탐지 솔루션 삭제
  mutDelZombiePcBlock (state, itemIndexList) {
    itemIndexList = itemIndexList.sort().reverse()
    for (const itemIndex of itemIndexList) {
      state.zombiePcBlockResult.splice(itemIndex, 1)
    }
  },
  // 좀비 PC 탐지 솔루션 사용여부 수정
  mutPutZombiePcBlockSync (state, payload) {
    state.zombiePcBlockSyncResult = payload
  },
  // 좀비 PC 탐지 솔루션 연동 조회
  mutZombiePcBlockLinkage (state, payload) {
    state.zombiePcBlockLinkageList = payload
  },
  mutZombiePcBlockLinkageReset (state) {
    state.zombiePcBlockLinkageList = []
  },
  mutUseZombiePcBlockLinkageList (state, {id, val}) {
    const tempDataList = _.cloneDeep(state.zombiePcBlockLinkageList)
    const idx = _.findIndex(tempDataList, o => o.zombie_id === id)
    if (idx === -1) return
    _.set(tempDataList, [idx, 'zombie_use_yn'], val)
    state.zombiePcBlockLinkageList = _.cloneDeep(tempDataList)
  },
  mutAllUseZombiePcBlockLinkageList (state, value) {
    const tempDataList = _.cloneDeep(state.zombiePcBlockLinkageList)
    _.forEach(tempDataList, o => {
      o.zombie_use_yn = value
    })
    state.zombiePcBlockLinkageList = _.cloneDeep(tempDataList)
  },
  // 좀비 PC 탐지 솔루션 연동 추가
  mutPostZombiePcBlockLinkage (state, payload) {
    state.zombiePcBlockLinkageResult = payload
  },
  // 좀비 PC 탐지 솔루션 연동 수정
  mutPutZombiePcBlockLinkage (state, payload) {
    state.zombiePcBlockLinkageResult = payload
  },
  // 좀비 PC 탐지 솔루션 연동 삭제
  mutDelZombiePcBlockLinkage (state, payload) {
    state.zombiePcBlockLinkageResult = payload
  },
  mutationErrorMessage (state, payload) {
    state.errorMessage = payload
  }
}

export const actions = {
  // 좀비 PC 탐지 솔루션 조회
  async acsZombiePcBlock ({commit, state}) {
    try {
      const res = await this.$axios.$get(`${state.apiUrl.zombiePcBlockUrl}/0`, {loading: false})
      if (res.code === 'ok') {
        commit('mutZombiePcBlock', res.result)
      } else {
        commit('mutZombiePcBlock', [])
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  // 좀비 PC 탐지 솔루션 편집 조회
  async acsZombiePcBlockGetData ({commit, state}, zombieCmId) {
    try {
      const data = await this.$axios.$get(`${state.apiUrl.zombiePcBlockUrl}/${zombieCmId}`, {loading: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('mutZombiePcBlockGetData', data.result)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 좀비 PC 탐지 솔루션 (빈설정)
  async acsAddEmptySettings ({commit, state}) {
    const param = _.omit(state.selectedData, ['zombie_cm_id'])
    const result = { error: null }
    try {
      const res = await this.$axios.$post(`${state.apiUrl.zombiePcBlockUrl}`, param, {loading: false, successAlert: false})
      return res
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  // 좀비 PC 탐지 솔루션 완료 처리 / 수정
  async acsPutZombiePcBlock ({commit, state}) {
    const result = { error: null }
    const params = state.selectedData
    // 수정 인 경우 device_id 추가
    if (state.selectedData.device_id_list === undefined) {
      params.device_id_list = []
      state.selectedData.zombie_cm_device.forEach(item => {
        params.device_id_list.push(item.device_id)
      })
    }
    try {
      const res = await this.$axios.$put(`${state.apiUrl.zombiePcBlockUrl}`, params, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        commit('mutPutZombiePcBlock', res)
      } else {
        result.error = res.result.msg
        commit('mutationErrorMessage', result)
      }
      return res
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  // 좀비 PC 탐지 솔루션 삭제 (연동으로 잘못기재됨. 2019/04/08 메인테이블 삭제용 restapi 임)
  async acsDelZombiePcBlock ({commit, state}, param) {
    try {
      const data = await this.$axios.$post(`${state.apiUrl.zombiePcBlockUrl}/multi`, param.idList, {loading: false, successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 좀비 PC 탐지 솔루션 사용여부 수정
  async acsPutZombiePcBlockSync ({commit, state}, payload) {
    const result = { error: null }
    try {
      const res = await this.$axios.$put(`${state.apiUrl.zombiePcBlockUrl}/multi`, payload)
      if (res.code === 'ok') {
        commit('mutPutZombiePcBlockSync', res)
      } else {
        result.error = res.result.msg
        commit('mutationErrorMessage', result)
      }
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  // 좀비 PC 탐지 솔루션 연동 조회
  async acsZombiePcBlockLinkage ({commit, state}, zombieCmId) {
    try {
      const data = await this.$axios.$get(`${state.apiUrl.zombiePcBlockLinkageUrl}/${zombieCmId}`, {loading: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('mutZombiePcBlockLinkage', data.result)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 좀비 PC 탐지 솔루션 연동 추가
  async acsPostZombiePcBlockLinkage ({commit, state}, zombieCmId) {
    const params = state.selectedLinkageData
    params.zombie_cm_id = zombieCmId
    try {
      const data = await this.$axios.$post(`${state.apiUrl.zombiePcBlockLinkageUrl}`, params, {loading: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 좀비 PC 탐지 솔루션 연동 수정
  async acsPutZombiePcBlockLinkage ({commit, state}) {
    const params = state.selectedLinkageData
    params.zombie_id = state.selectLinkageRowItem.zombie_id
    try {
      const data = await this.$axios.$put(`${state.apiUrl.zombiePcBlockLinkageUrl}`, params, {loading: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 좀비 PC 탐지 솔루션 연동 삭제
  async acsDelZombiePcBlockLinkage ({commit, state}, param) {
    try {
      const data = await this.$axios.$post(`${state.apiUrl.zombiePcBlockLinkageUrl}/multi`, param.idList, {loading: false, successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 메인 화면, 사용 미사용 설정.
  async onEventRuleChkInputAxios ({commit, state}, param) {
    try {
      const data = await this.$axios.$put(`${state.apiUrl.zombiePcBlockUrl}/multi`, param, {loading: false, successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 좀비 PC 탐지 솔루션 연동 사용/미사용 설정
  async setZombiePcBlockLinkageUsed ({commit, state}, param) {
    try {
      const data = await this.$axios.$put(`${state.apiUrl.zombiePcBlockLinkageUrl}/multi`, param, {loading: false, successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  }
}

export const getters = {
}

export const strict = false
